export const ACTIVE_INDEX = 'ACTIVE_INDEX';

// Thunk to set the active index
export const basicDetailsCallApi = (index) => (dispatch) => {
  dispatch({
    type: ACTIVE_INDEX,
    payload: index,
  });
};
